import { render, staticRenderFns } from "./perCenter.vue?vue&type=template&id=08ec0b06&scoped=true&"
import script from "./perCenter.vue?vue&type=script&lang=js&"
export * from "./perCenter.vue?vue&type=script&lang=js&"
import style0 from "./perCenter.vue?vue&type=style&index=0&id=08ec0b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec0b06",
  null
  
)

export default component.exports